export default __webpack_public_path__ + "static/media/7.294b0304.webp";